import React from "react";
import { Box } from "@mui/material";

export interface FilterBarProps {
  /** Filter controls (selects, search, etc.). */
  children: React.ReactNode;
  /** Right-aligned slot (e.g. result count, bulk actions). */
  right?: React.ReactNode;
}

/**
 * Horizontal toolbar that hosts filters/search above a DataTable. Wraps on
 * narrow screens. Sits on the page background (not inside the table card).
 */
export default function FilterBar({ children, right }: FilterBarProps) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        flexWrap: "wrap",
        gap: 1.5,
        mb: 2,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, flexWrap: "wrap" }}>{children}</Box>
      {right && <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>{right}</Box>}
    </Box>
  );
}
